// extracted by mini-css-extract-plugin
module.exports = {"parameter":"ParameterList_parameter__1Y2DC","label":"ParameterList_label__15efD","value":"ParameterList_value__uTQ9s"};